var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"control"},[_c('label',{attrs:{"for":"html"}},[_vm._v("Article:")]),_vm._v(" "),_c('wysiwyg',{model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_vm._v(" "),_c('counter',{attrs:{"value":_vm.wordsCount,"min-count":_vm.minWords}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }